import React from 'react'
import {FaPhoneAlt,FaMapMarkerAlt,FaLinkedin,FaGlobe,FaQuora,FaMediumM} from 'react-icons/fa'
import {FiInstagram} from 'react-icons/fi'
import {ImStackoverflow} from 'react-icons/im'
import {MdEmail} from 'react-icons/md'
import {AiFillGithub,AiFillFacebook,AiOutlineTwitter,AiFillSkype} from 'react-icons/ai'

const SingleSocial = (props) => {
    return ( <>
        { (props.content !== undefined && props.content !== null && props.content !== '') ?
        <div className="social-item">
            <span className="pre-icon">{props.icon}</span>
            <p className="para-text">{props.content}</p>
        </div> : <></>
        }
        </>
    )
}

function Social(props) {
    return (
        <>
            <p className="heading-text"> CONTACT </p>
            <SingleSocial icon={<MdEmail/>} content={props.email}/>
            <SingleSocial icon={<FaPhoneAlt/>} content={props.phone}/>
            <SingleSocial icon={<FaMapMarkerAlt/>} content={props.address}/>
            <SingleSocial icon={<FaGlobe/>} content={props.website}/>
            <SingleSocial icon={<FaLinkedin/>} content={props.linkedin}/>
            <SingleSocial icon={<AiFillGithub/>} content={props.github}/>
            <SingleSocial icon={<AiFillFacebook/>} content={props.facebook}/>
            <SingleSocial icon={<FiInstagram/>} content={props.instagram}/>
            <SingleSocial icon={<AiOutlineTwitter/>} content={props.twitter}/>
            <SingleSocial icon={<AiFillSkype/>} content={props.skype}/>
            <SingleSocial icon={<FaQuora/>} content={props.quora}/>
            <SingleSocial icon={<ImStackoverflow/>} content={props.stackoverflow}/>
            <SingleSocial icon={<FaMediumM/>} content={props.medium}/>
        </>
    )
}

export default Social
